import React, { FC, ReactNode } from 'react';
import cn from 'classnames';

import { Info } from 'views/icons';

interface Props {
  title?: string;
  children: ReactNode;
  emphasis?: boolean;
  className?: string;
}

// Plain informational box for disclaimers and eligibility notes.
const Notice: FC<Props> = ({ title, children, emphasis, className }) => (
  <div
    className={cn('aifs notice', { notice_emphasis: emphasis }, className)}
    role="note"
  >
    <span className="centered notice__icon">
      <Info />
    </span>
    <div className="notice__content">
      {title && <h4 className="p3 text-semi-bold notice__title">{title}</h4>}
      <p className="p4 notice__text">{children}</p>
    </div>
  </div>
);

export default Notice;
